import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";
import Header from "../Header/Header";

function People() {
    return (<Header>
        
    </Header>)
}

export default People;